const s = "_status_14ex8_1", t = {
  status: s
};
export {
  t as default,
  s as status
};
//# sourceMappingURL=status.module.less.js.map
